//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('membersController', ['$scope', 'members', 'progressBar', 'ngDialog', 'commonDialog',
      'commonDialogMessage', '$stateParams', '$state', 'uiGridConstants', 'agencySelectService',
      'clientSelectService', 'toastFactory', 'authService', '$timeout',
      function($scope, members, progressBar, ngDialog, commonDialog, commonDialogMessage, $stateParams, $state,
        uiGridConstants, agencySelectService, clientSelectService, toastFactory, authService, $timeout) {
        const progress = progressBar.getProgressBar();
        $scope.showAllAgents = members.getShowAll();
        var emailRegex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
        $scope.validate = { //'valid', 'invalid', 'not-validated'
          emailValidity: 'not-validated',
          firstNameValidity: 'not-validated',
          lastNameValidity: 'not-validated',
          passwordValidity: 'not-validated',
          confirmValidity: 'not-validated',
        };

        const agency = agencySelectService.getSelectedAgency();

        $scope.confirmPassword = null;
        let gridData;
        $scope.member = {
          Id: 0,
          FirstName: null,
          LastName: null,
          Email: null,
          OrganizationId: 0,
          IsAdmin: false,
          AccountEnabled: false,
          DisableSMS: false,
          AllowAgentAccess: true,
          Phone: null,
          CustomerAccountNumber: null,
          Password: null,
          TripLinkEmail: null,
        };
        $scope.edit = function() {
          $state.go('app.editAgent', {
            id: $scope.rowSelectingId,
          });
        };
        $scope.searchAgents = function() {
          members.setShowAll($scope.showAllAgents);
          setGridData();
        };
        //Call this code while edit member
        let id = $stateParams.id;
        if (!!id) {
          getMemberById(id);
        };
        // ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        // ui-grid options
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          exporterMenuPdf: false,
          exporterMenuCsv: false,
          multiSelect: false,
          columnDefs: [{
            name: 'FirstName',
            enableHiding: false,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'LastName',
            displayName: 'Last Name',
            enableHiding: false,
            enableFiltering: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Email',
            visible: true,
            enableHiding: true,
            enableFiltering: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Phone',
            displayName: 'Phone',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'IsAdmin',
            displayName: 'Admin Access',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'AccountEnabled',
            displayName: 'Account Enabled',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, ],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
        };

        $scope.gridDetails = _.cloneDeep(gridOptions);
        $scope.gridDetails.onRegisterApi = function (gridApi) {
          $scope.gridApi = gridApi;
          $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
            if (!sortColumns.length) {
              paginationOptions.sort = null;
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction;
            }
            updateGridPagination(gridData);
          });
          // Row Selection
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            $scope.rowSelectingId = row.entity.Id;
            if (row.isSelected) {
              $scope.rowSelecting = true;
              if (row.entity.AccountEnabled === 'No') {
                $scope.disabledDeleteBtn = false;
              } else {
                $scope.disabledDeleteBtn = true;
              }
            } else {
              $scope.rowSelecting = false;
              $scope.disabledDeleteBtn = false;
            }
          });
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            updateGridPagination(gridData);
          });
        };

        $scope.onDblClick = function(row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view();
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        var allAgentsData = [];
        function updateGridPagination(gridData) {
          $scope.isExportData = !!gridData.length ? true : false;
          allAgentsData = gridData;
          $scope.gridDetails.data = gridData;
          $scope.gridDetails.totalItems = gridData.length;
        };

        function setGridData() {
          if (authService.getLoginMember().Role === 4) {
            getAgentsByObexAdmin();
          } else {
            getAgentsByAgencyAdmin();
          }
        };

        function getAgentsByObexAdmin() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid) {
            progress.start();
            members.getMembersByOrgId(agencySelectService.getSelectedAgency().id).then(function(response) {
                const agentsData = response.data;
                let agents = [];
                if ($scope.showAllAgents !== true) {
                  agents = agentsData.filter(function(agent) {
                    return agent.AccountEnabled;
                  }).map(function(agent) {
                    return {
                      Id: agent.Id,
                      FirstName: agent.FirstName,
                      LastName: agent.LastName,
                      Phone: agent.Phone,
                      Email: agent.Email,
                      AccountEnabled: ((agent.AccountEnabled) ? 'Yes' : 'No'),
                      IsAdmin: ((agent.IsAdmin) ? 'Yes' : 'No'),
                    };
                  });
                } else {
                  agents = agentsData.map(function(agent) {
                    return {
                      Id: agent.Id,
                      FirstName: agent.FirstName,
                      LastName: agent.LastName,
                      Phone: agent.Phone,
                      Email: agent.Email,
                      AccountEnabled: ((agent.AccountEnabled) ? 'Yes' : 'No'),
                      IsAdmin: ((agent.IsAdmin) ? 'Yes' : 'No'),
                    };
                  });
                }
                gridData = agents;
                updateGridPagination(gridData);
            }, function (err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Agent Error';
                },],
              });
            })
              .finally(function () {
                progress.complete();
              });
          }
        };

        function getAgentsByAgencyAdmin() {
          progress.start();
          members.getMembers().then(function(response) {
              const agentsData = response.data;
              let agents = [];
              if ($scope.showAllAgents !== true) {
                agents = agentsData.filter(function(agent) {
                  return agent.AccountEnabled;
                }).map(function(agent) {
                  return {
                    Id: agent.Id,
                    FirstName: agent.FirstName,
                    LastName: agent.LastName,
                    Phone: agent.Phone,
                    Email: agent.Email,
                    AccountEnabled: ((agent.AccountEnabled) ? 'Yes' : 'No'),
                    IsAdmin: ((agent.IsAdmin) ? 'Yes' : 'No'),
                  };
                });
            } else {
              agents = agentsData.map(function (agent) {
                return {
                  Id: agent.Id,
                  FirstName: agent.FirstName,
                  LastName: agent.LastName,
                  Phone: agent.Phone,
                  Email: agent.Email,
                  AccountEnabled: ((agent.AccountEnabled) ? 'Yes' : 'No'),
                  IsAdmin: ((agent.IsAdmin) ? 'Yes' : 'No'),
                };
              });
            }
            gridData = agents;
            updateGridPagination(gridData);
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Agent Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };
        setGridData();

        function getMemberById(id) {
          progress.start();
          members.getMemberById(id).then(function(member) {
              $scope.member = member.data;
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Get Member Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };
        //update First and Last Name
        function updateName() {
          const member = $scope.member;
          members.updateName(member.Id, member).then(function (member) {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Edit Agent Success';
                $scope.successMsg = 'The Agent has been edited succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.agents');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Update Agent Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };
        //Enable Disable Account and Delete the account
        $scope.deleteAccount = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Agent?';
              $scope.strMsg = 'Do you really want to delete this agent?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              members.deleteAccount($scope.rowSelectingId).then(function (del) {
                const dialogDel = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Delete Agent Success';
                    $scope.successMsg = 'Agent deleted successfully';
                  },],
                });
                dialogDel.closePromise.then(function (data) {
                  $scope.gridApi.core.clearAllFilters();
                  setGridData();
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Delete Agent Error';
                    },],
                  });
                }
              })
                .finally(function () {
                  progress.complete();
                });
            }
          });
        };

        $scope.exportReport = function() {
          $scope.gridDetails.data = allAgentsData;
          $scope.gridDetails.exporterCsvFilename = agency.name+'_Agents.csv';
          $timeout(function() {
            $scope.gridApi.exporter.csvExport('all', 'all');
            
            updateGridPagination(allAgentsData);
          }, 100);
        }

        //Set/reset admin access to user
        function setAdmin() {
          progress.start();
          members.setAdmin($scope.member.Id, $scope.member.IsAdmin).then(function(del) {
            enableAccount();
          }, function (err) {
            progress.complete();
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                $scope.errTitle = 'Agent Error';
              },],
            });
          });
        };
        //Enable Disable Account and Delete the account
        function enableAccount() {
          members.setEnableDisableAccount($scope.member.Id, $scope.member.AccountEnabled).then(function(del) {
            updateName();
          }, function(err) {
            progress.complete();
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                $scope.errTitle = 'Delete Agent Error';
              },],
            });
          });
        };
        //Save function
        $scope.updateAgent = function() {
          setAdmin();
        };
        $scope.view = function(rowId) {
          const selectId = !!rowId ? rowId : $scope.rowSelectingId;
          if (selectId) {
            getMemberById(selectId);
          }
          ngDialog.open({
            template: 'templates/partials/viewAgent.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };
        $scope.saveAgent = function() {
          if (!!agencySelectService.getSelectedAgency().id) {
            let member = $scope.member;
            var isEmailValid = emailRegex.test(member.Email);
            var isPasswordValid = passwordRegex.test(member.Password);
            ((!isEmailValid) ? $scope.validate.emailValidity = 'invalid' : $scope.validate.emailValidity =
              'valid');
            ((!member.FirstName) ? $scope.validate.firstNameValidity = 'invalid' : $scope.validate.firstNameValidity =
              'valid');
            ((!member.LastName) ? $scope.validate.lastNameValidity = 'invalid' : $scope.validate.lastNameValidity =
              'valid');
            ((!isPasswordValid) ? $scope.validate.passwordValidity = 'invalid' : $scope.validate.passwordValidity =
              'valid');
            ((member.Password !== $scope.confirmPassword) ? $scope.validate.confirmValidity = 'invalid' : $scope.validate
              .confirmValidity = 'valid');
            var emailInvalid = $scope.validate.emailValidity === 'invalid',
              firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
              lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
              passwordInvalid = $scope.validate.passwordValidity === 'invalid',
              confirmInvalid = $scope.validate.confirmValidity === 'invalid';
            if (emailInvalid || firstNameInvalid || lastNameInvalid || passwordInvalid || confirmInvalid) {
              $scope.ajaxload = false;
              const dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '';
                  if (firstNameInvalid) {
                    $scope.errMsg += '<p>First name must be entered.</p>';
                  }
                  if (lastNameInvalid) {
                    $scope.errMsg += '<p>Last name must be entered.</p>';
                  }
                  if (emailInvalid) {
                    $scope.errMsg += '<p>Email is invalid.</p>';
                  }
                  if (passwordInvalid) {
                    $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
                  }
                  if (confirmInvalid) {
                    $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
                  }
                  $scope.errTitle = 'Add Agent Error';
                },],
              });
              dialog.closePromise.then(function (data) { });
            } else {
              progress.start();
              member.OrganizationId = agencySelectService.getSelectedAgency().id;
              members.saveAgent(member).then(function (data) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Add Agent Success';
                    $scope.successMsg = 'The Agent has been created succesfully.';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $state.go('app.agents');
                });
              }, function (err) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'Save Agent Error';
                  },],
                });
              })
                .finally(function () {
                  progress.complete();
                });
            }
          } else {
            //toastFactory.toast_info('Please select an agency.');
          }
        };        
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
          };
        }        
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return agencySelectService.getSelectedAgency();
        }, function(newValue, oldValue) {
          if (authService.getLoginMember().Role === 4) {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid) {
              if (newValue !== oldValue) {
                members.setShowAll(false);
                $scope.showAllAgents = false;
                $scope.gridDetails.data = [];
                $scope.gridDetails.totalItems = 0;
                setGridData();
              }
            } else {
              if (valid.agencyValid === false) {
                $scope.gridDetails.data = [];
                $scope.gridDetails.totalItems = 0;
                //toastFactory.toast_info('Please select an agency.');
              }
            }
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/membersController.js